/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import _main from '@/js/main';
/**
 * EHR-MOB 관련 JS
 */
var _mob = {
  active: '',
  environment: '',
  fromType: '',
  commCdList: [], // 공통코드 목록

  /**
   * active 조회
   */
  getActive: function () {
    var active;
    _mob.ajax(
      process.env.VUE_APP_API_URL + 'api/active',
      {},
      function (resData) {
        active = resData;
      },
      { async: false },
    );
    _mob.active = active;
    return active;
  },

  /**
   * environment 조회
   */
  getEnvironment: function () {
    var environment;
    _mob.ajax(
      process.env.VUE_APP_API_URL + 'api/environment',
      {},
      function (resData) {
        environment = resData;
      },
      { async: false },
    );
    _mob.environment = environment;
    return environment;
  },

  /**
   * fromType 조회
   *
   */
  getFromType: function () {
    var fromType;
    _mob.ajax(
      process.env.VUE_APP_API_URL + 'api/fromType',
      {},
      function (resData) {
        fromType = resData;
      },
      { async: false },
    );
    _mob.fromType = fromType;
    return fromType;
  },

  /**
   * 로그인 사용자 정보 return
   */
  getLoginUser: function () {
    var loginUser;
    _mob.ajax(
      '/loginUser',
      {},
      function (resData) {
        loginUser = resData;
      },
      { async: false },
    );

    return loginUser;
  },

  /**
   * 포털 로그인 URL
   *
   */
  getPortalLoginUrl: function () {
    var portalLoginUrl;
    _mob.ajax(
      '/portalLoginUrl',
      {},
      function (resData) {
        portalLoginUrl = resData;
      },
      { async: false },
    );
    _mob.portalLoginUrl = portalLoginUrl;
    return portalLoginUrl;
  },

  /**
   * document title
   */
  documentTitle: 'BGF 리테일 BPM',

  /**
   * <header><title> 세팅
   *
   * @param title 세팅할 title(default : documentTitle)
   */
  title: function (title) {
    title = title || _mob.documentTitle;
    document.title = title;
  },

  loadingCount: 0,

  /**
   * 로딩바 보이기 / 숨기기
   *
   * @param isShow 보여줄 지 여부(true:보이기, false:숨기기)
   */
  loading: function (isShow) {
    var loading = $('#_loading');

    if (isShow == true) {
      if (loading.length == 0) {
        loading = $('<div>')
          .attr('id', '_loading')
          .addClass('loading_bg')
          .append(
            $('<div>')
              .addClass('spinner_box')
              .append($('<img>').attr('src', '/common/images/spinner.png')),
          );
        $('body').append(loading);
      }
      loading.show();

      this.loadingCount++;

      //console.log(this.loadingCount + " : " + isShow);
    } else {
      this.loadingCount--;
      //console.log(this.loadingCount + " : " + isShow);

      if (this.loadingCount < 0) {
        this.loadingCount = 0;
      }

      if (this.loadingCount == 0) {
        loading.hide();
      }
    }
  },

  /**
   * AJAX 호출
   *
   * @param url 호출 URL
   * @param data 전송 데이터
   * @param success 호출 성공시 실행할 함수
   * @param options 기타 옵션, 아래 정의된 옵션은 BPM에서 정의된 옵션. 그외는 jquery ajax의 settings 참조
   *                - loading : ajax 실행시 로딩바 보여줄 지 여부(default:true)
   */
  ajax: function (url, data, success, options) {
    options = options || {};

    var resData;

    // 기본 option
    var defaultOptions = {
      async: true,
      method: 'post',
    };

    // jquery ajax settings
    var settings = $.extend(defaultOptions, options);

    // 전송 데이터 세팅
    settings.data = data;

    // 로딩바 보여줄지 여부
    var loading = options.loading === undefined ? true : options.loading;

    // beforeSend 함수
    settings.beforeSend = function (xhr, settings) {
      // 로딩바 show
      if (loading === true) {
        _mob.loading(true);
      }

      if (options.beforeSend) {
        options.beforeSend(xhr, settings);
      }
    };

    // 성공 함수
    settings.success = function (res, textStatus, xhr) {
      try {
        if (success) {
          success(res, textStatus, xhr);
        }
      } catch (e) {
        _mob.loading(false);
        throw e;
      }
    };

    // error
    settings.error = async function (xhr, textStatus, errorThrown) {
      console.log('[AJAX 에러 발생] = ', xhr);

      xhr.abort();

      var errorInfo = xhr.responseJSON;
      if (errorInfo == undefined) {
        try {
          errorInfo = JSON.parse(xhr.responseText);
        } catch (e) {
          console.log(e);
        }
      }

      var errorCode = errorInfo.errorCode || xhr.status + ''; // 에러 코드
      var errorMessage = errorInfo.errorMessage; // 에러 메시지
      var redirectPage = errorInfo.redirectPage; // 이동할 페이지

      // 메시지
      await _mob.alert(errorMessage, { title: errorCode });

      // 로딩바 show
      if (loading === true) {
        _mob.loading(false);
      }

      // 이동할 페이지가 있으면 해당 화면으로 이동
      if (redirectPage) {
        if (_mob.environment == 'mobile') {
          redirectPage += location.search;
        }

        if (opener) {
          opener.location.href = redirectPage;
          self.close();
        } else {
          self.location.href = redirectPage;
        }
      }
      // 이동할 페이지가 없으면 error 함수 호출
      else {
        if (options.error) {
          options.error(xhr, textStatus, errorThrown);
        }
      }
    };

    // complete 함수
    settings.complete = function (xhr, textStatus) {
      // 로딩바 show
      if (loading === true) {
        _mob.loading(false);
      }

      if (options.complete) {
        options.complete(resData, xhr, textStatus);
      }
    };

    var xhr = $.ajax(url, settings);

    // sync 이면서 에러 발생시 throw
    if (options.async == false && xhr.status != '200') {
      if (loading == true) {
        _mob.loading(false);
      }
      throw url + ' 실행 중 에러 발생';
    }

    return xhr;
  },

  /**
   * 이벤트 추가
   *
   * @param element 이벤트를 걸 요소
   * @param eventType 이벤트 유형(ex. click, dblclick ...)
   * @param fn 이벤트 발생시 실행할 함수
   */
  addEvent: function (element, eventType, fn) {
    var el = _mob.getElement(element);
    el.on(eventType, fn);
  },

  /**
   * 이벤트 trigger
   * @param element 이벤트를 걸 요소
   * @param eventType 이벤트 유형(ex. click, dblclick ...)
   */
  triggerEvent: function (element, eventType) {
    var el = _mob.getElement(element);
    el.trigger(eventType);
  },

  /**
   * 숫자만 입력
   * ex) onkeyup="_mob.inNumber(this);"
   */
  inNumber: function (obj, event) {
    if (event) {
      _mob.addEvent(obj, event, function () {
        _mob.setValue(obj, this.value.replace(/[^0-9]/g, ''));
      });
    } else {
      _mob.setValue(obj, _mob.getValue(obj).replace(/[^0-9]/g, ''));
    }
  },

  setMaxBytes: function (obj, bytes, event) {
    if (event) {
      _mob.addEvent(obj, event, function () {
        _mob.setValue(obj, _mob.getBytesText(this.value, bytes).value);
      });
    }
  },

  /**
   * 공통 금액 입력
   * ex) onkeyup="_mob.numberWonTypeInput(this);
   */
  numberWonTypeInput: function (obj) {
    var val = obj.value;
    val = val.replace(/,/gi, '');
    var regexp = /^[0-9]*$/;

    if (!regexp.test(val)) {
      $(obj).val('');
    } else {
      val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      $(obj).val(val);
    }
  },

  /**
     * json을 key=value 형태로 delimiter로 연결해서 String으로 변경
     * ex) {type:"POP", data:"DATA"};
            ==> type=POP&data=DATA
     * @param data json 형태의 데이터
     * @param delimiter 데이터와 데이터 사이의 구분자(default:+)
     * @param prefix key 앞에 붙일 값
     *                 ex) data = {a:"a1", b:"b1"}
     *                     delimiter = "&"
     *                     prefix = "p"
     *                     ==>  p.a=a1&p.b=b1
     * @param isBase64 BASE64 인코딩할지 여부(true, false)
     */
  getStringFromJson: function (data, delimiter, prefix, isBase64) {
    delimiter = delimiter || '+';

    var str = '';
    $.each(data, function (key, value) {
      value = data[key];
      convert(key, value);
    });

    function convert(key, value) {
      if ($.isArray(value) == true) {
        $.each(value, function (i, value2) {
          convert(key + '[' + i + ']', value2);
        });
      } else if ($.type(value) == 'object') {
        $.each(value, function (key2, value2) {
          convert(key + '.' + key2, value2);
        });
      } else {
        addValue((prefix ? prefix + '.' : '') + key, value);
      }
    }

    function addValue(key, value) {
      str +=
        (str == '' ? '' : delimiter) +
        key +
        '=' +
        (isBase64 == true ? Base64.encode(value) : value);
    }

    return str;
  },

  /**
   * "+" 로 연결된 key=value 형태를 json으로 변경
   * ex) type=POP+data=DATA ==> {type:"POP", data:"DATA"}
   *
   * @param data string 형태의 데이터
   * @param delimiter 데이터와 데이터 사이의 구분자(default:+)
   */
  getJsonFromString: function (data, delimiter) {
    delimiter = delimiter || '+';

    var json = {};
    if (data) {
      $.each(data.split(delimiter), function (i, param) {
        var key = param.split('=')[0];
        var value = param.split('=')[1];
        json[key] = value;
      });
    }

    return json;
  },

  /**
   * JSON 형태의 데이터의 value가 undefined, null, "null" 이면 "" 로 세팅
   */
  setNullToBlank: function (data) {
    if (data) {
      for (var key in data) {
        var value = data[key];
        if ($.type(value) == 'object') {
          _mob.setNullToBlank(value);
        } else {
          data[key] = _mob.isEmpty(value) == true ? '' : value;
        }
      }
    }
  },

  /**
   * 통합 체크
   */
  isEmpty: function (params) {
    if ($.type(params) == 'object') {
      if ($.isEmptyObject(params)) {
        return true;
      } else {
        return false;
      }
    } else {
      return (
        params == null ||
        params == 'null' ||
        params == undefined ||
        params == ''
      );
    }

    //return params == null || params == "null" || params == undefined || params == "";
  },

  /**
   * <, >, 줄바꿈, 공백 을 html 로 변경
   *
   * @param str 변경할 문자열
   * @return html로 변경된 문자열
   */
  convertHtml: function (str) {
    str = str || '';

    return str
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\n/g, '<br/>')
      .replace(/ /g, '&nbsp');
  },

  /**
   * Byte를 단위에 맞게 변환
   */
  formatBytes: function (bytes, decimals = 1) {
    if (bytes === 0) return '0 B';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  },

  /**
   * value의 byte를 계산해서
   * byte 수와 size에 맞게 자른 text를 return
   *
   * @param value 계산할 text
   * @param size 최대 bytes
   * @returnm {
   *              byte : byte 수,
   *              value : size에 맞게 자른 text
   *          }
   */
  getBytesText: function (value, size) {
    var $bytes = 0;
    var returnTemp = '';
    if (!value || value.length == 0) return 0;
    var charCode, chr;
    for (var i = 0; i < value.length; i++) {
      chr = value.charAt(i);
      charCode = chr.charCodeAt(0);
      if (charCode <= 0x00007f) $bytes += 1;
      else if (charCode <= 0x0007ff) $bytes += 2;
      else if (charCode <= 0x00ffff) $bytes += 3;
      else $bytes += 4;

      if (size >= $bytes) returnTemp = returnTemp + chr;
    }

    return { byte: $bytes, value: returnTemp };
  },

  /**
   * BPMS 파라미터 전송시 사용금지 문자 체크
   * 금지 문자 발견시 true / 없을경우 false
   *
   * ex) '+', '='
   *
   * @param orgStr
   * @returns {Boolean}
   */
  chkParamAvoidChar: function (orgStr) {
    var ret = false;

    if (orgStr.indexOf('+') > -1) {
      ret = true;
    } else if (orgStr.indexOf('=') > -1) {
      ret = true;
    } else if (orgStr.indexOf('^') > -1) {
      ret = true;
    } else if (orgStr.indexOf('#') > -1) {
      ret = true;
    }

    return ret;
  },

  /**
   * Alert 창
   *
   * 이 함수를 사용하기 위해서는 이 함수를 호출하는 함수에 async 를,
   * 이 함수를 호출하는 부분에 await를 선언해야
   * 확인 버튼 클릭 후 이후 로직이 시작 된다. (선언을 하지 않으면 이후 로직이 바로 실행.)
   * ex)
   * async function fnc() {
   *     await _mob.alert("메시지"); <-- 확인 버튼을 클릭하기 전까지 여기에 멈춤
   *     console.log("확인 버튼 클릭 후 실행"); <-- alert 창이 닫히면 실행.
   * }
   *
   * callback 함수를 이용할 경우에는 async, await를 선언하지 않아된다. (단 함수 이후 로직 바로 실행)
   * ex)
   * function fnc() {
   *     _mob.alert("메시지", {callback : function() {
   *         console.log("확인 버튼 클릭시 실행");
   *     }
   *     console.log("확인 버튼 클릭 전보다 먼저 실행");
   * }
   *
   * @param message 메시지
   * @param option alert창 option(jquery ui dialog option 에 아래 항목 추가)
   *        - callback : 확인 버튼 클릭시 callback 함수
   * @param 확인 : true, x 버튼 : undefined
   */
  alert: async function (message, options) {
    var result = false;

    await _mob.alertMessage('alert', message, options).then(function (res) {
      result = res;
    });

    return result;
  },

  /**
   * Confirm 창
   *
   * 이 함수를 사용하기 위해서는 이 함수를 호출하는 함수에 async 를,
   * 이 함수를 호출하는 부분에 await를 선언해야 confirm 결과를 받을 수 있고
   * 이후 로직이 시작 된다. (선언을 하지 않으면 결과를 받을 수 없고 이후 로직이 바로 실행.)
   * ex)
   * async function fnc() {
   *     var result = await _mob.alertConfirm("메시지"); <-- 확인 버튼(또는 취소 버튼)을 클릭하기 전까지 여기에 멈춤
   *     console.log("결과 : " + result); <-- confirm 창이 닫히면 실행.
   * }
   *
   * callback 함수를 이용할 경우에는 async, await를 선언하지 않아된다. (단 함수 이후 로직 바로 실행)
   * ex)
   * function fnc() {
   *     _mob.confirm("메시지", {
   *             okCallback : function() {
   *                 console.log("확인 버튼 클릭시 실행");
   *             },
   *             cancelCallback : function() {
   *                 console.log("취소 버튼 클릭시 실행");
   *             }
   *     console.log("확인 / 취소 버튼 클릭 전보다 먼저 실행");
   * }
   *
   * @param message 메시지
   * @param option alert창 option(jquery ui dialog option 에 아래 항목 추가)
   *        - okCallback : 확인 버튼 클릭시 callback 함수
   *        - cancelCallback : 취소 버튼 클릭 시 callback 함수
   *        - okText : 확인 버튼 text(default:확인)
   *        - cancelText : 취소 버튼 text(default:취소)
   * @return 확인 : true, 취소 : false, x 버튼 : undefined
   */
  confirm: async function (message, options) {
    var result = false;

    await _mob.alertMessage('confirm', message, options).then(function (res) {
      result = res;
    });

    return result;
  },

  /**
   * Alert, Confirm 창
   * 자세한 내용은 alert, confirm 함수 참조
   */
  alertMessage: function (type, message, options) {
    // 기본 값 세팅
    type = type || 'alert';
    options = options || {};
    options.newline = options.newline == undefined ? true : options.newline;
    message = options.newline == true ? _mob.convertHtml(message) : message;

    // async 방식으로 처리하기 위해 defer 선언
    var defer = $.Deferred();

    // 기본 옵션
    var defaultOption = {
      modal: true,
      autoOpen: false,
      resizable: false,
      closeOnEscape: false,
      close: function (e) {
        // 닫힐 때 발생하는 이벤트

        // 10 밀리초 지연을 준 이유는
        // x 버튼을 클릭 했을 때 undefined 를 넘기기 위해서 이다.
        // 이 이벤트는 dialog가 닫힐 때 무조건 발생하므로
        // 확인, 취소 버튼을 클릭 해도 발생한다.
        // 10 밀리초를 지연 시키므로 해서
        // 확인, 취소 버튼 클릭시 결과(true, false)를 먼저 결과로 return 하고
        // x 버튼을 클릭했을 때는 undefined를 return 한다.
        setTimeout(function () {
          defer.resolve(undefined);
        }, 10);

        // dialog 삭제
        $('#alertDialog').remove();
      },
    };

    // type에 대한 option
    var typeOption = {
      alert: {
        // Alert 창
        title: _mob.convertHtml(options.title) || '확인',
        buttons: [
          {
            text: '확인',
            class: 'buttonOk',
            icon: 'ui-icon-ok',
            open: function (event, ui) {
              $('.ui-dialog-titlebar-close').remove();
            },
            click: function (e) {
              div.dialog('close');
              if (options.callback) {
                options.callback(true);
              }

              defer.resolve(false);
            },
          },
        ],
      },
      confirm: {
        // Confirm 창
        title: _mob.convertHtml(options.title) || '확인',
        open: function (event, ui) {
          $('.ui-dialog-titlebar-close').remove();
        },
        buttons: [
          {
            text: '확인',
            class: 'buttonOk',
            icon: 'ui-icon-ok',
            click: function () {
              div.dialog('close');
              if (options.okCallback) {
                options.okCallback(true);
              }

              defer.resolve(true);
            },
          },
          {
            text: '취소',
            icon: 'ui-icon-cancel',
            click: function () {
              div.dialog('close');
              if (options.cancelCallback) {
                options.cancelCallback(false);
              }

              defer.resolve(false);
            },
          },
        ],
      },
    };

    var div = $('<div>').attr('id', 'alertDialog').html(message);
    $('<html>').append(div);

    var option = $.extend({}, defaultOption, typeOption[type], options);
    //div.dialog(option);
    //div.dialog('open');

    return defer.promise();
  },

  /**
   * input text에서 enter시 콜백 함수 호출
   *
   * @param areaObj input text를 찾을 범위
   * @param callback enter 시 호출할 함수
   */
  enterCallback: function (areaObj, callback) {
    areaObj = _mob.getElement(areaObj);
    setTimeout(function () {
      areaObj
        .find("input[type='text'], input[type='password']")
        .each(function () {
          _mob.enterCallBackElement($(this), callback);
        });
    }, 1);
  },

  /**
   * element 에 엔터시 콜백함수 호출
   */
  enterCallBackElement: function (obj, callback) {
    obj = _mob.getElement(obj);
    obj.on('keyup', function (e) {
      if (e.keyCode == 13 && callback) {
        e.stopPropagation();
        callback(e);
      }
    });
  },

  /**
   * 현재 컨텐츠 내에서 객체 가져오기
   */
  /**
   * 현재 컨텐츠 내에서 객체 가져오기
   */
  getElement: function (obj) {
    if ($.type(obj) != 'object') {
      if (typeof _main != 'undefined' && _main.page.selected) {
        var el = $('#page_' + _main.page.selected.pageCd + ' ' + obj);
        if (el.length == 0) {
          var id = obj.replace(/\\\\/g, '\\').replace('#', '');
          try {
            el = $(
              '#page_' + _main.page.selected.pageCd + " [org_id='" + id + "']",
            );
          } catch (e) {
            console.log(e);
          }
        }
        obj = el;
      } else {
        obj = $(obj);
      }
    }

    return obj;
  },

  /**
   * Element 의 값 가져오기
   * checkbox 인 경우에는 배열로 return
   */
  getValue: function (obj) {
    var element = _mob.getElement(obj);
    var value = '';

    if (element.length > 0) {
      var tagName = element.get(0).tagName.toLowerCase();
      var type = element.attr('type');

      // 체크 박스
      if (type == 'checkbox' || type == 'radio') {
        if (type == 'checkbox') {
          value = [];
          element.each(function () {
            if (this.checked == true) {
              value.push(this.value);
            }
          });
        } else if (type == 'radio') {
          element.each(function () {
            if (this.checked == true) {
              value = this.value;
            }
          });
        }
      }
      // 그외
      else {
        value = element.val();
      }
    }

    return value;
  },

  /**
   * Element 에 값 세팅
   */
  setValue: function (obj, value) {
    var element = _mob.getElement(obj);
    if (element.length > 0) {
      var tagName = element.get(0).tagName.toLowerCase();
      var type = element.attr('type');

      // 체크박스, 라디오
      if (type == 'checkbox' || type == 'radio') {
        var values = $.makeArray(value);
        element.each(function () {
          var obj = $(this);
          $.each(values, function () {
            var checked = obj.val() == this;
            obj.prop('checked', obj.val() == this);
            if (checked == true) {
              return false;
            }
          });
        });
      }
      // 그외
      else {
        element.val(value);
      }
    }
  },
  /**
   * Element 에 값 세팅
   */
  setText: function (obj, value) {
    var element = _mob.getElement(obj);
    element.text(value);
  },

  /**
   * Element Text return
   */
  getText: function (obj) {
    var element = _mob.getElement(obj);
    return element.text();
  },

  setHtml: function (obj, value) {
    var element = _mob.getElement(obj);
    element.html(value);
  },

  /**
   * 포커스
   */
  focus: function (obj) {
    _mob.getElement(obj).focus();
  },

  /**
   * 페이지 이동
   */
  goPage: function (url, data) {
    // 메뉴 데이터
    data = $.extend(
      {
        menuCd: _main.page.selected.menuCd,
        url: url,
      },
      data,
    );

    _mob.ajax('/page/get', data, function (resData) {
      if (resData) {
        _main.selectPage(resData.pageCd, data, true);
      }
    });
  },

  /**
   * 공통코드 목록 조회
   *
   * @param grpCommCd 공통코드 그룹코드
   * @param type 유형 (bpm:TOBE 공통코드, job:JOB계정의 COMM100 테이블)
   * @param useYn 사용여부(Y:사용, N:미사용, A:사용/미사용 모두 조회)
   */
  getCommCdList: function (grpCommCd, type, useYn) {
    var commCdList = _mob.commCdList[grpCommCd] || [];
    useYn = (useYn || 'Y').toUpperCase();

    if ($.isEmptyObject(commCdList) == true) {
      grpCommCd = grpCommCd || ' ';
      type = type || 'bpm';

      var data = {
        grpCommCd: grpCommCd,
        useYn: useYn == 'A' ? '' : useYn,
      };

      var url = '/bpsa/bpsa1000/listCommCd';
      if (type == 'job') {
        url = '/copu/job/listCommCd';
      }

      _mob.ajax(
        url,
        data,
        function (resData) {
          if (resData) {
            commCdList = resData;
            _mob.commCdList[grpCommCd] = commCdList;
          }
        },
        { async: false },
      );
    }

    var resultList = [];
    $.each(commCdList, function () {
      if (useYn == 'A' || this.useYn == useYn || type != 'bpm') {
        resultList.push(this);
      }
    });

    return resultList;
  },

  /**
   * 공통코드명 가져오기
   */
  getCommCdNm: function (grpCommCd, commCd, type) {
    var commCdList = _mob.getCommCdList(grpCommCd, type, 'A') || [];
    var commCdNm = '';
    $.each(commCdList, function () {
      if (this.commCd == commCd) {
        commCdNm = this.commCdNm;
        return false;
      }
    });

    return commCdNm;
  },

  /**
   * 공통코드로 라디오 버튼 만들기
   *
   * @param grpCommCd 공통코드 그룹코드
   * @param name input name
   * @param options 옵션
   *           - checkedValue : 체크할 값
   *           - target : 라디오 버튼을 append 할 element
   * @return options.target 이 있으면 tartget 에 append 하고 return 안함.
   *         options.target 이 없으면 html return
   */
  makeRadioCommCd: function (grpCommCd, name, options) {
    return _mob.makeCheckRadioCommCd('radio', grpCommCd, name, options);
  },

  /**
   * 공통코드로 체크박스/라디오 만들기
   *
   * @param grpCommCd 공통코드 그룹코드
   * @param name input name
   * @param options 옵션
   *           - checkedValue : 체크할 값, 2개 이상일 때는 배열로 세팅
   *           - target : 체크박스를 append 할 element
   * @return options.target 이 있으면 tartget 에 append 하고 return 안함.
   *         options.target 이 없으면 html return
   */
  makeCheckboxCommCd: function (grpCommCd, name, options) {
    return _mob.makeCheckRadioCommCd('checkbox', grpCommCd, name, options);
  },

  /**
   * 공통코드로 체크박스/라디오 만들기
   *
   * @param type 유형(radio, checkbox)
   * @param grpCommCd 공통코드 그룹코드
   * @param name input name
   * @param options 옵션
   *           - firstOption : 첫번째 option 세팅
   *                         : true 이면 <input type='radio' value=''/>전체 가 세팅
   *                         : json 형태 이면 json의 value, text를 세팅
   *                           ex) {value : "0", text : "선택"} --> <input type='radio' value='0'/>선택 이 세팅
   *           - checkedValue : 체크할 값, 2개 이상일 때는 배열로 세팅
   *           - disabled : 비활성화 여부
   *           - target : 체크박스를 append 할 element
   *           - event : 항목(input)에 bind 할 event
   *           - type : 유형
   *                 bpm : TOBE 공통코드(기본값)
   *                 job : JOB 계정의 COMM100
   * @return options.target 이 있으면 tartget 에 append 하고 return 안함.
   *         options.target 이 없으면 html return
   */
  makeCheckRadioCommCd: function (type, grpCommCd, name, options) {
    options = options || {};

    var checkedValues =
      $.isArray(options.checkedValue) == true
        ? options.checkedValue
        : [options.checkedValue];

    // 공통코드 목록 조회
    var commCdList = _mob.getCommCdList(grpCommCd, options.type);

    // 첫번 째 option 세팅
    if ($.type(options.firstOption) == 'object') {
      commCdList.unshift({
        commCd: options.firstOption.value,
        commCdNm: options.firstOption.text,
      });
    } else if (options.firstOption === true) {
      commCdList.unshift({ commCd: '', commCdNm: '전체' });
    }

    // wrap
    var wrap = $('<div>').addClass(
      _mob.environment == 'mobile' ? 'chkbox' : 'radiobox',
    );
    var ul = $('<ul>');

    // 라디오 버튼 만들기
    $.each(commCdList, function (i, data) {
      var li = $('<li>');
      var id = name + '_' + data.commCd;
      var checkbox = $('<input>')
        .attr('type', type)
        .attr('name', name)
        .attr('id', id)
        .prop('disabled', options.disabled)
        .val(data.commCd);

      var label = $('<label>')
        .attr('id', 'label_' + id)
        .attr('for', id)
        .text(data.commCdNm);

      // 이벤트 bind
      $.each(options.event, function (event, fn) {
        checkbox.on(event, function () {
          _mob.callback(fn, this.value, checkbox);
        });
      });

      if (checkedValues.includes(data.commCd)) {
        checkbox.trigger('click');
        checkbox.trigger('change');
      }

      li.append(checkbox).append('\n').append(label);
      ul.append(li);
    });

    wrap.append(ul);

    // 값 세팅
    //_mob.setValue("[name='"+ name +"']", checkedValues);

    // option 에 target 이 있으면 target 에 붙이기. 없으면 html return
    if (options.target) {
      var target = _mob.getElement(options.target);
      target.append(wrap);
    } else {
      return wrap;
    }
  },

  /**
   * 공통코드로 콤보 만들기
   *
   * @param type 유형(radio, checkbox)
   * @param grpCommCd 공통코드 그룹코드
   * @param name select name
   * @param options 옵션
   *           - firstOption : 첫번째 option 세팅
   *                         : all 이면 <option value="">전체</option>이 세팅
   *                         : true 이면 <option value="">선택</option>이 세팅
   *                         : json 형태 이면 json의 value, text를 세팅
   *                           ex) {value : "0", text : "=== 선택 ==="} --> <option value="0">=== 선택 ===</option>
   *           - selectedValue : 체크할 값, 2개 이상일 때는 배열로 세팅
   *           - target : 체크박스를 append 할 element
   *           - css : select 태그에 적용될 css
   *           - class : select 태그에 적용될 class
   *           - didabled : 비활성시킬지 여부
   *           - type : 유형
   *                 bpm : TOBE 공통코드(기본값)
   *                 job : JOB 계정의 COMM100
   * @return options.target 이 있으면 tartget 에 append 하고 return 안함.
   *         options.target 이 없으면 html return
   */
  makeComboCommCd: function (grpCommCd, name, options) {
    options = options || { disabled: false };

    var selecedValues =
      $.isArray(options.selectedValue) == true
        ? options.selectedValue
        : [options.selectedValue];
    var css = options.css || {};

    // 공통코드 목록 조회
    var commCdList = _mob.getCommCdList(grpCommCd, options.type);

    // select
    var select = $('<select>')
      .attr('name', name)
      .attr('id', name)
      .addClass('w_100')
      .addClass('sel_grid_01')
      .addClass(options.class || '')
      .css(css);

    if (css.width != undefined) {
      select.removeClass('w_100');
    }

    // option
    options = $.extend({}, { firstOption: true }, options);
    _mob.addComboOptions(select, commCdList, 'commCd', 'commCdNm', options);

    // 이벤트 _mob.addComboOptions 에서 이벤트 bind 하므로 주석처리함.
    /*if ($.isArray(options.event) == true) {
            $.each(options.event, function(i, event) {
                if (event) {
                    $.each(event, function(eventName, fn) {
                        _mob.addEvent(select, eventName, fn)
                    })
                }
            });
        }*/

    // 비활성 시킬지 여부
    select.prop('disabled', options.disabled);

    // option 에 target 이 있으면 target 에 붙이기. 없으면 html return
    if (options.target) {
      var target = _mob.getElement(options.target);
      target.children().remove();
      target.append(select);
    } else {
      return $('<div>').append(select).html();
    }
  },

  /**
   * combo(select 태그)의 option 추가
   *
   *  @param comboObj 콤보 객체("#id", $("#id") 형태)
   *  @param optionList option 목록
   *  @param valueKey optionList에서 value에 세팅할 key
   *  @param textKey optionList에서 text에 세팅할 key
   *  @param options 기타 옵션
   *                  1) firstOption : 첫번째 option 세팅
   *                                 : true 이면 <option value="">선택</option>이 세팅
   *                                 : json 형태 이면 json의 value, text를 세팅
   *                                   ex) {value : "0", text : "=== 선택 ==="} --> <option value="0">=== 선택 ===</option>
   *                  2) selectedValue : 콤보 option이 추가된 후 선택할 option의 value
   *                                     여러개 일 경우에는 배열로 세팅
   *                  3) reset : 기존 콤보 삭제할지 여부(true, false)
   *                  4) event : 콤보에 event bind
   *                             ex) {event:{chanage:function() {}}}
   *
   */
  addComboOptions: function (comboObj, optionList, valueKey, textKey, options) {
    options = options || {};
    comboObj = _mob.getElement(comboObj);

    if (options.reset === true) {
      comboObj.children().remove();
    }

    // 첫번 째 option 세팅
    if ($.type(options.firstOption) == 'object') {
      let firstOption = $('<option>')
        .attr('value', options.firstOption.value)
        .text(options.firstOption.text);
      comboObj.append(firstOption);
    } else if (options.firstOption == 'all') {
      let firstOption = $('<option>')
        .attr('value', '')
        .attr('text', '전체')
        .text('전체');
      comboObj.append(firstOption);
    } else if (options.firstOption === true) {
      let firstOption = $('<option>')
        .attr('value', '')
        .attr('text', '선택')
        .text('선택');
      comboObj.append(firstOption);
    }

    // option 추가
    $.each(optionList, function (i, option) {
      comboObj.append(
        $('<option>')
          .attr('value', option[valueKey])
          .attr('text', option[textKey])
          .text(option[textKey]),
      );
    });

    // 값 세팅
    if ($.isArray(options.selectedValue) == true) {
      $.each(options.selectedValue, function (i, val) {
        comboObj.find("option[value='" + val + "']").attr('selected', true);
      });
    } else {
      comboObj.val(options.selectedValue);
    }

    // event 바인딩
    options.event = $.makeArray(options.event);
    $.each(options.event, function (i, event) {
      comboObj.on(event);
    });
    /*
        // option 선택
        var selectedValues = $.isArray(options.selectedValue) == true ? options.selectedValue : [options.selectedValue];
        $.each(selectedValues, function(i, val) {
            comboObj.find("option[value='" + val + "']").attr("selected", true);
        });
        */
  },

  addHiddenInput: function (target, key, value) {
    if ($.type(value) == 'object') {
      $.each(value, function (subKey, subValue) {
        _mob.addHiddenInput(target, key + '.' + subKey, subValue);
      });
    } else {
      var input = $('<input>')
        .attr('id', key)
        .attr('name', key)
        .attr('type', 'hidden')
        .attr('value', value);
      _mob.getElement(target).append(input);
    }
  },

  /**
   * 콜백
   */
  callback: function (
    callback,
    data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
  ) {
    if (callback == undefined) {
      return;
    }

    if ($.type(callback) == 'function' || $.type(callback) == 'object') {
      callback(
        data1,
        data2,
        data3,
        data4,
        data5,
        data6,
        data7,
        data8,
        data9,
        data10,
      );
    } else {
      var cs = callback.split('.');
      var fn = window;
      $.each(cs, function (i) {
        fn = fn[this];
      });

      if (fn) {
        fn(
          data1,
          data2,
          data3,
          data4,
          data5,
          data6,
          data7,
          data8,
          data9,
          data10,
        );
      }
    }
  },

  /**
   * 사원 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchUser: function (options) {
    options.searchKey = 'user';
    options.codeKey = 'loginId';
    options.nameKey = 'userNm';
    options.popup = '_popup.openUserPopup';
    _mob.commonSearch('user', '/copu/copu0100/listUser', options);
  },

  /**
   * 사원 조회 후 default 콜백 함수
   */
  callbackUserSearch: function (data) {
    _mob.callbackCommonSearch('user', data);
  },

  /**
   * 조직 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchDept: function (options) {
    options.searchKey = 'dept';
    options.codeKey = 'deptCd';
    options.nameKey = 'deptNm';
    options.popup = '_popup.openDeptPopup';
    _mob.commonSearch('dept', '/copu/copu0200/listDept', options);
  },

  /**
   * 조직 조회 후 default 콜백 함수
   */
  callbackDeptSearch: function (data) {
    _mob.callbackCommonSearch('dept', data);
  },

  /**
   * 직무 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchDuty: function (options) {
    options.searchKey = 'duty';
    options.codeKey = 'dutyCd';
    options.nameKey = 'dutyNm';
    options.popup = '_popup.openDutyPopup';
    _mob.commonSearch('duty', '/copu/copu0300/listDuty', options);
  },

  /**
   * 맵핑 프로세스 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchMapProc: function (options) {
    options.searchKey = 'procMap';
    options.codeKey = 'procMapCd';
    options.nameKey = 'procMapNm';
    options.popup = '_popup.openMapProcPopup';
    _mob.commonSearch('MapProc', '/copu/copu2000/listMapProcList', options);
  },

  /**
   * 직무 조회 후 default 콜백 함수
   */
  callbackDutySearch: function (data) {
    _mob.callbackCommonSearch('duty', data);
  },

  /**
   * 프로세스 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchProcess: function (options) {
    options.searchKey = 'proc';
    options.codeKey = 'procCd';
    options.nameKey = 'procNm';
    options.popup = '_popup.openProcessPopup';
    _mob.commonSearch('process', '/copu/copu0400/listProc', options);
  },

  /**
   * 프로세스 조회 후 default 콜백 함수
   */
  callbackProcessSearch: function (data) {
    _mob.callbackCommonSearch('process', data);
  },

  /**
   * Task 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchTask: function (options) {
    options.searchKey = 'task';
    options.codeKey = 'taskCd';
    options.nameKey = 'taskNm';
    options.popup = '_popup.openTaskPopup';
    _mob.commonSearch('task', '/copu/copu0600/listTask', options);
  },

  /**
   * 프로세스 조회 후 default 콜백 함수
   */
  callbackTaskSearch: function (data) {
    _mob.callbackCommonSearch('task', data);
  },

  /**
   * 점포 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchStore: function (options) {
    options.searchKey = 'store';
    options.codeKey = 'storeCd';
    options.nameKey = 'storeNm';
    options.popup = '_popup.openStorePopup';
    _mob.commonSearch('store', '/copu/copu0900/listStore', options);
  },

  /**
   * 점포 조회 후 default 콜백 함수
   */
  callbackStoreSearch: function (data) {
    _mob.callbackCommonSearch('store', data);
  },

  /**
   * P.P 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchPP: function (options) {
    options.searchKey = 'pp';
    options.codeKey = 'ppNo';
    options.nameKey = 'ppNm';
    options.popup = '_popup.openPPPopup';
    _mob.commonSearch('pp', '/copu/copu1000/listPP', options);
  },

  /**
   * P.P 조회 후 default 콜백 함수
   */
  callbackPpSearch: function (data) {
    _mob.callbackCommonSearch('pp', data);
  },

  /**
   * 가맹계약코드 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchContract: function (options) {
    options.searchKey = 'fcStore';
    options.codeKey = 'fcStoreCd';
    options.nameKey = 'fcStoreNm';
    options.popup = '_popup.openContractPopup';
    _mob.commonSearch('contract', '/copu/copu1100/listContract', options);
  },

  /**
   * 가맹계약코드 조회 후 default 콜백 함수
   */
  callbackContractSearch: function (data) {
    _mob.callbackCommonSearch('contract', data);
  },

  /**
   * 물건 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code1 : 물건코드 값을 세팅할 element
   *          - code2 : 물건코드-체결번호 값을 세팅할 element
   *          - name : 물건명 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchPreStore: function (options) {
    options.searchKey = 'preStore';
    options.codeKey1 = 'preStoreCd';
    options.codeKey2 = 'preStoreCd2';
    options.nameKey = 'preStoreNm';
    options.popup = '_popup.openPreStorePopup';
    _mob.commonSearch('preStore', '/copu/copu1200/listPreStore', options);
  },

  /**
   * 가맹객 조회
   *
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  searchHopeGuest: function (options) {
    options.searchKey = 'hopeGuest';
    options.codeKey = 'commCode';
    options.nameKey = 'commName1';
    options.popup = '_popup.openHopeGuestPopup';
    _mob.commonSearch('hopeGuest', '/copu/copu1600/listHopeGuest', options);
  },

  /**
   * 가맹객 조회 후 default 콜백 함수
   */
  callbackHopeGuestSearch: function (data) {
    _mob.callbackCommonSearch('hopeGuest', data);
  },

  /**
   * 공통 조회
   * @param type 유형
   * @param url 조회 url
   * @param option 옵션
   *          - target : change, enter 이벤트기 적용될 element
   *          - code : code 값을 세팅할 element
   *          - name : name 값을 세팅할 element
   *          - codeKey : 결과의 code key
   *          - nameKey : 결과의 name key
   *          - data : 조회조건에 세팅할 값
   *          - popup : 결과가 2개 이상일 때 호출할 함수명
   *          - before : 조회전 실행할 함수
   *          - callback : 콜백 함수. 없으면 자동으로 code, name에 값 세팅
   */
  commonSearch: function (type, url, options) {
    var targetObj = _mob.getElement(options.target);
    var btnObj = _mob.getElement(options.button);
    var callback =
      options.callback ||
      '_mob.callback' +
        type.substring(0, 1).toUpperCase() +
        type.substring(1) +
        'Search';
    var eventCount = 0; // 이벤트 중복 방지를 위한 변수

    options.type = type;
    _mob.commSearchOptions = _mob.commSearchOptions || {};
    _mob.commSearchOptions[_main.page.selected.pageCd] =
      _mob.commSearchOptions[_main.page.selected.pageCd] || [];
    _mob.commSearchOptions[_main.page.selected.pageCd][type] = options;

    // 조회
    var _search = function () {
      if (eventCount > 0) {
        return;
      }

      eventCount++;

      var value = targetObj.val();
      var options = _mob.commSearchOptions[_main.page.selected.pageCd][type];
      var codeObj = _mob.getElement(options.code);
      var nameObj = _mob.getElement(options.name);

      if (!value) {
        codeObj.val('');
        nameObj.val('');
        eventCount--;

        if (callback) {
          if (callback == '_mob.callbackCommonSearch') {
            _mob.callback(callback, type, {});
          } else {
            _mob.callback(callback, {});
          }
        }

        return;
      }

      // before 함수가 있으면 실행
      if (options.before) {
        _mob.callback(options.before, options);
      }

      // 조회조건
      var searchData = $.extend({}, options.data);
      searchData[options.searchKey] = value;

      // 사용자 조회
      _mob.ajax(url, searchData, function (resData) {
        eventCount--;

        // 데이터가 없을 경우
        if (resData.length == 0) {
          setTimeout(function () {
            codeObj.val('');
            nameObj.val('');
          }, 10);
        }
        // 데이터가 1개일 경우
        else if (resData.length == 1) {
          if (callback) {
            if (callback == '_mob.callbackCommonSearch') {
              _mob.callback(callback, type, resData[0]);
            } else {
              _mob.callback(callback, resData[0]);
            }
          }
        }
        // 데이터가 1개 이상일 경우
        else if (resData.length > 1) {
          _mob.callback(options.popup, searchData, callback, {});
          nameObj.val('');
        }
      });
    };

    _mob.enterCallBackElement(targetObj, _search); // enter 시 사용자 조회
    _mob.addEvent(targetObj, 'change', _search); // blur 사용자 조회
    _mob.addEvent(btnObj, 'click', function () {
      // before 함수가 있으면 실행
      if (options.before) {
        _mob.callback(options.before, options);
      }

      // 조회조건
      var searchData = $.extend({}, options.data);
      if (targetObj.val()) {
        searchData[options.searchKey] = targetObj.val();
      }

      // 팝업
      _mob.callback(options.popup, searchData, callback);
    });
  },
  /**
   * 공통 조회후 기본 콜백 함수
   */
  callbackCommonSearch: function (type, data) {
    var options = _mob.commSearchOptions[_main.page.selected.pageCd][type];
    var codeObj = _mob.getElement(options.code);
    var nameObj = _mob.getElement(options.name);

    // 코드 세팅
    if (options.code) {
      codeObj.val(data[options.codeKey]);
    }

    // 명 세팅
    if (options.name) {
      nameObj.val(data[options.nameKey]);
    }
  },

  /**
   * 공통 조회 시 조회조건 데이터 세팅
   * @param 유형
   * @param data 조회조건
   * @param isAppend 기존 조회조건에 추가할 건지 덮어쓸건지 여부(true:추가(default), false:덮어씀)
   */
  setCommonSearchData: function (type, data, isAppend) {
    isAppend = isAppend == undefined ? true : false;
    var options = _mob.commSearchOptions[_main.page.selected.pageCd][type];
    options.data = options.data || {};
    if (isAppend == true) {
      options.data = $.extend(true, {}, options.data, data);
    } else {
      options.data = data;
    }

    _mob.commSearchOptions[_main.page.selected.pageCd][type] = options;
  },

  /**
   * 아코디언 세팅(펼치기, 접기)
   */
  setAccodion: function (btnObj, targetObj, toggleClass) {
    _mob.addEvent(btnObj, 'click', function () {
      _mob.getElement(btnObj).toggleClass(toggleClass);
      _mob.getElement(targetObj).toggle({ effect: 'blind', duration: 300 });
    });
  },

  /**
   * 메뉴 데이터 개수를 표시하는 메뉴코드 배열
   */
  getHasMenuCountMenu: function () {
    var menuCds = [];
    setMenuCd();
    return menuCds;

    function setMenuCd(menuList) {
      menuList = menuList || _main.page.list || [];
      menuList.forEach(function (menu) {
        if (menu.countYn == 'Y') {
          menuCds.push(menu.menuCd);
        }

        if ($.isEmptyObject(menu.childList) == false) {
          setMenuCd(menu.childList);
        }
      });
    }
  },
  /**
   * 메뉴 데이터 개수 조회
   */
  getMenuCount: function (menuCd, callback) {
    _mob.ajax(
      '/menu/count',
      { menuCd: menuCd },
      function (resData) {
        _mob.callback(callback, resData);
      },
      { loading: false },
    );
  },

  /**
   * 쿠키에 저장
   * @param key 키
   * @param value 값
   * @param expires 만료일. 기본값 1년
   */
  setCookie: function (key, value, expires) {
    expires = expires || 365;

    var expiresDate = new Date();
    expiresDate.setDate(expiresDate.getDate() + expires);
    document.cookie =
      key +
      '=' +
      encodeURIComponent(Base64.encode(value)) +
      '; expires=' +
      expiresDate.toUTCString();
  },

  /**
   * 쿠키에서 값 가져오기
   * @param key 키
   */
  getCookie: function (key) {
    var value = '';
    var split = document.cookie.split(';');
    $.each(split, function (i, c) {
      var split2 = $.trim(c).split('=');
      var key2 = split2[0];
      var value2 = split2[1];
      var b = false;

      if (key == key2) {
        value = Base64.decode(decodeURIComponent(value2));
        b = true;
      }

      if (b == true) {
        return false;
      }
    });

    return value;
  },

  /**
   * Task 완료 여부
   *
   * @param taskId Task ID
   * @return Y:완료, N:미완료
   */
  checkCompleteTask: function (taskId) {
    var data = {
      taskId: taskId,
    };
    var result = 'N';
    _mob.ajax(
      '/bpur/bpur0200/completeTask',
      data,
      function (resData) {
        result = resData;
      },
      { async: false },
    );

    return result;
  },

  /**
   * text 복사
   */
  copyText: function (text) {
    var tempElem = document.createElement('textarea');
    tempElem.value = text;
    document.body.appendChild(tempElem);

    tempElem.select();
    document.execCommand('copy');
    document.body.removeChild(tempElem);
  },

  /**
   * toast
   *
   * @param text 보여질 문구
   * @param time time 이후 사라짐(밀리세컨드, 기본값 1000)
   */
  toast: function (text, time) {
    time = time == undefined ? 1000 : time;

    // toast 만들기
    var wrapObj = $('.toast');
    if (wrapObj.length == 0) {
      wrapObj = $('<div>').addClass('toast');
      wrapObj.append($('<div>').addClass('text'));
      $('#area_contents').append(wrapObj);
    } else {
      wrapObj.show();
    }

    // 기존 toast 초기화
    clearTimeout(_mob.timeoutToast);
    wrapObj.stop();
    wrapObj.css('opacity', 1);

    // 문구 세팅
    var textObj = wrapObj.find('.text');
    textObj.text(text);

    // time 밀리초 후 사라짐
    _mob.timeoutToast = setTimeout(function () {
      wrapObj.fadeOut(1000);
    }, time);
  },

  timeoutToast: 0,
};

/*
$(document).ready(function () {
  //_mob.title(); // title 세팅
  //_mob.active = _mob.getActive();
  //_mob.environment = _mob.getEnvironment();
  //_mob.fromType = _mob.getFromType();
  //_mob.portalLoginUrl = _mob.getPortalLoginUrl();
});
*/
export default _mob;
